angular.module('lsnBase.filters')
  .filter('yearToData', function(){
    return function(year) {
      if(!year || !(new XDate(year, 1, 1).valid())){
        return year;
      }
      return new XDate(year, 0, 1).toString('yyyy-MM-dd');
    };
});